import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { getCurrentSubCategory } from 'SRC/modules/categories/selectors'
import { Item } from 'SRC/modules/ads/add/components/FormPage/PromoPeriodsNew/Item'
import { AdApi } from 'SRC/modules/ads/shared/api'
import { CookiesHelper } from 'Core/cookiesHelper/CookiesHelper'
import { getAdForPromo, getUserInfo } from '../../selectors'
import { setProfileLoading, setActivatePromoError, setNotifications } from '../../actions'
import Router from 'next/router'
import { notificationTypes, profileMenu } from '../../constants'

export class PromoPeriods extends React.PureComponent {
  state = {activeListing: null}

  onListingChange = event => {
    const value = Number(event.target.dataset.id)
    this.setState({...this.state, activeListing: value})
  }

  onPromoActivate = async event => {
    event.preventDefault()
    const helper = new CookiesHelper()
    const token = helper.get('token')
    const userId = helper.get('userId')
    const listing = this.state.activeListing
    const adId = this.props.ad.id
    if (token && userId && listing && adId) {
      await this.props.setProfileLoading(true)
      const fields = {token, userId, adId, listing}
      const api = new AdApi()
      const {status, message} = await api.promote(fields)
      if (status === AdApi.responseTypes.OK) {
        const hrefUrl = `/profile`
        const asUrl = `/profil/${profileMenu.ads.code}`
        const query = {page: profileMenu.ads.code}
        const selectedListing = this.props.listings.filter(item => item.id === listing)
        if (selectedListing.length) {
          const notifications = []

          notifications.push({
            type: notificationTypes.USER_ADDED_PAID_AD,
            info: {
              ad: {code: this.props.ad.code, listing: selectedListing[0]},
              user: this.props.user
            }
          })

          this.props.setNotifications(notifications)
        }
        setTimeout(() => {
          Router.push({pathname: hrefUrl, query}, {pathname: asUrl}).then(() => window.scrollTo(0, 0))
        }, 5000)
      } else {
        this.props.setActivatePromoError(message)
        this.props.setProfileLoading(false)
      }
    }
  }

  render () {
    const {listings} = this.props
    return (
      <form className='dodavanje-oglasa-form-podaci' onSubmit={this.onPromoActivate}>
        <div className='tipovi-oglasa'>
          {listings.map(item =>
            <Item
              {...item}
              key={item.id}
              onClick={this.onListingChange}
              isActive={this.state.activeListing === item.id}
            />
          )}
        </div>
        <button className='btn-oglas-submit ads-add__submit' type='submit' disabled={!this.state.activeListing}>
          Pošalji zahtjev
        </button>
      </form>
    )
  }
}

const mapStateToProps = state => {
  let listings = []

  const currentSubcategory = getCurrentSubCategory(state)
  if (currentSubcategory && Array.isArray(currentSubcategory.listings)) {
    listings = currentSubcategory.listings.filter(listing => listing.price > 0)
  }

  return {
    listings,
    ad: getAdForPromo(state),
    user: getUserInfo(state)
  }
}

PromoPeriods.propTypes = {
  listings: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired),
  ad: PropTypes.shape({
    id: PropTypes.number.isRequired,
    code: PropTypes.string.isRequired
  }),
  setActivatePromoError: PropTypes.func.isRequired,
  setProfileLoading: PropTypes.func.isRequired,
  setNotifications: PropTypes.func.isRequired,
  user: PropTypes.shape({
    name: PropTypes.string.isRequired,
    surname: PropTypes.string
  }).isRequired
}

export default connect(
  mapStateToProps, {setProfileLoading, setActivatePromoError, setNotifications}
)(PromoPeriods)
